KMVP.forms = {

    disableSubmitButton: function($form) {
        var submitButton = $form.find('button[type="submit"]');
        submitButton.attr('disabled', true);
    },

    enableSubmitButton: function($form) {
        var submitButton = $form.find('button[type="submit"]');
        submitButton.attr('disabled', false);
    },
}

